export default "__VITE_ASSET__KxBFQiP6__"